import moment from 'moment';
import { hoursOfOperation } from '../const';

export default function() {
  // get adjusted open and close times if in a different time zone.
  const timezone = moment.tz.guess(true); // bool arg ignores cache
  const now = moment(new Date()).tz(timezone);
  const newYork = moment(new Date()).tz('America/New_York'); // NY time is default
  const differenceInHours = (newYork._offset - now._offset) / 60;

  // handles behind (differenceInHours positive values).  For Times ahead, temp fix is for users to manually change timezone to NYC in system preferences
  const open =
    differenceInHours > 0
      ? hoursOfOperation.open - differenceInHours
      : hoursOfOperation.open;

  const close =
    differenceInHours > 0
      ? hoursOfOperation.close - differenceInHours
      : hoursOfOperation.close;

  return {
    open,
    close
  };
}



// WEBPACK FOOTER //
// ./src/helpers/timeZoneOffset.js